<template>
  <div class="content">
    <div class="title">项目问题管理表</div>
    <div class="report-column">
      <el-input></el-input>
      <el-button type="primary" icon="el-icon-search">搜索</el-button>
      <el-button>导出</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="项目问题管理表" header-align="center">
        <el-table-column label="项目名称: 项目报表测试" width="120">
          <el-table-column type="index" label="序号" width="60">
          </el-table-column>
          <el-table-column prop="p1" label="风险出现日期" width="120">
          </el-table-column>
          <el-table-column prop="p2" label="提出人" width="100">
          </el-table-column>

        </el-table-column>
        <el-table-column label="项目成员:张三,李四,王五">
          <el-table-column prop="p3" label="项目阶段" width="120">
          </el-table-column>
          <el-table-column prop="p4" label="样机版本" width="120">
          </el-table-column>
          <el-table-column prop="p5" label="问题描述" width="100">
          </el-table-column>
          <el-table-column prop="p6" label="原因分析" width="120">
          </el-table-column>
          <el-table-column prop="p7" label="问题类型" width="120">
          </el-table-column>
          <el-table-column prop="p8" label="问题影响程度" width="120">
          </el-table-column>
          <el-table-column prop="p9" label="问题应对措施" width="100">
          </el-table-column>
          <el-table-column prop="p10" label="责任人" width="120">
          </el-table-column>
          <el-table-column prop="p11" label="状态更新" width="120">
          </el-table-column>
          <el-table-column prop="p12" label="计划关闭日期" width="120">
          </el-table-column>
          <el-table-column prop="p13" label="问题状态" width="120">
          </el-table-column>
          <el-table-column prop="p14" label="实际关闭日期" width="120">
          </el-table-column>
          <el-table-column prop="p15" label="造成延期时间" width="120">
          </el-table-column>
          <el-table-column prop="p16" label="备注" width="120">
          </el-table-column>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { manageData } from './riskData';
export default {
  data() {
    return {
      tableData: []
    }
  },
  created() {
    this.tableData = manageData
  },
}
</script>

<style scoped>
.content {
  padding: 25px;
  padding-top: 5px;
}

.title {
  margin: 10px auto;
  font-size: 1.4em;
  font-weight: 600;
  text-align: center;
}

.report-column {
  width: 600px;
  margin: 15px auto;
  display: flex;
  gap: 1em
}
</style>